import { styled } from 'styled-components';

import { Box } from '#/components/Box/Box';
import { transition } from '#/theme/theme';

export const FormStep = styled(Box)<{ $active: boolean }>`
  position: ${(props) => (props.$active ? 'static' : 'absolute')};
  z-index: ${(props) => (props.$active ? 1 : 0)};
  visibility: ${(props) => (props.$active ? 'visible' : 'hidden')};
  overflow: ${(props) => (props.$active ? 'visible' : 'hidden')};
  height: ${(props) => (props.$active ? 'auto' : 0)};
  opacity: ${(props) => (props.$active ? 1 : 0)};
  pointer-events: ${(props) => (props.$active ? 'auto' : 'none')};
  top: 0;
  left: 0;
  width: 100%;
  transition: all ${transition};
`;
